<template>
	<ActivityBadgeLayout class="archive-goal-activity-badge">
		<FontAwesomeIcon v-if="isArchived" :icon="[ `fas`, `box-archive` ]" />
		<FontAwesomeIcon v-else :icon="[ `fas`, `box-open` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "ArchiveGoalActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
	props: {
		isArchived: {
			type: Boolean,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color2-500;
$badgeBackgroundColor: $color2-100;

.archive-goal-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
